import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AuthService } from '@core/services/auth/auth.service';
import { Popover } from 'primeng/popover';
import { User } from '@core/models';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  standalone: false,
})
export class AppTopbarComponent {
  layoutService = inject(LayoutService);
  private authService = inject(AuthService);
  @ViewChild('op') op!: Popover;

  @ViewChild('menubutton') menuButton!: ElementRef;

  user: User | null;
  constructor() {
    this.user = this.authService.user;
  }

  get name(): string {
    if (!this.user) return '';
    const firstName = this.user.firstName || this.user.first_name || 'C';
    const lastName = this.user.lastName || this.user.last_name || 'A';

    if (!firstName || !lastName) return '';

    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showProfileSidebar();
  }
  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  onFilterButtonClick() {
    console.log('Filter button clicked');
  }

  toggle($event: Event) {
    this.op.toggle($event);
  }

  showPopOver() {
    this.op.show(true);
  }

  hidePopOver() {
    this.op.hide();
  }
}
